import { TemplateKey } from "PFApp/constants/templates";
import { Button } from "PFComponents/button";
import { Checkbox } from "PFComponents/checkbox";
import { Inline } from "PFComponents/containers";
import { Activity } from "PFCore/types";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import { useActivityFormStore } from "../../../activity_form_store";
import { useActivityFormSubmit } from "../../../hooks/use_activity_form_submit";
import css from "../footer.module.scss";
import { EditModeButtons } from "./parts/edit_mode_buttons";

export const EngagementFooter = () => {
  const { t } = useTranslation("activities", { keyPrefix: "form.footer" });
  const navigate = useNavigate();

  const { isNew, isEdit, isDraft, isAudit } = useActivityFormStore((state) => state.activityStatus);
  const [createAsDraft, setCreateAsDraft] = useState(isDraft);

  const onSubmit = useActivityFormSubmit();

  const handleCreateAndAddRoles = () => {
    onSubmit({
      draft: createAsDraft,
      navigateCallback: ({ id }: Activity) =>
        navigate(
          `/activities/${isAudit ? TemplateKey.AuditRole : TemplateKey.Role}/new?parentActivityId=${id}`
        )
    });
  };

  return (
    <>
      <Inline as="span" gap="spacingLg">
        {isNew && (
          <>
            <Checkbox label={t("createAsDraft")} checked={createAsDraft} onChange={setCreateAsDraft} />
            <Button
              kind="secondary"
              text={t(isAudit ? "createWithoutAuditRoles" : "createWithoutRoles")}
              onClick={() => onSubmit({ draft: createAsDraft })}
              className={css.footerButton}
            />
            <Button
              kind="primary"
              text={t(isAudit ? "createAndAddAuditRoles" : "createAndAddRoles")}
              onClick={() => handleCreateAndAddRoles()}
              className={css.footerButton}
            />
          </>
        )}
        {isEdit && <EditModeButtons />}
      </Inline>
    </>
  );
};
